export const ZIndex = {
  ModalBackground: 1,
  ModalContent: 2,
  ModalBottom: 3,
  ModalContainer: 11,
  ToastContent: 4,
  LoadingBackground: 12,
  CalendarModal: 5,
};
